import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import Footer from 'components/Footer';
import PathNavigationBar from 'components/PathNavigationBar';

import {
  DataPrivacy,
  GetStartedToday,
  Headline,
  HowItWorks,
  Overview,
} from './components';

type HomeProps = {};

const HomePage: React.FC<HomeProps> = () => {
  const [fixed, setFixed] = useState<boolean>(false);

  const setFixedSidebar = () => {
    if (window.scrollY >= 500) {
      setFixed(true);
    } else {
      setFixed(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', setFixedSidebar);

    return () => {
      window.removeEventListener('scroll', setFixedSidebar);
    };
  }, []);

  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
    >
      <Headline />
      <Grid
        container
        display='flex'
        flexDirection='row-reverse'
        spacing={0}
        mt={5}
        maxWidth={{
          xs: '370px',
          sm: '750px',
          md: '1000px',
          lg: '1600px',
        }}
      >
        <Grid item xs={12} sm={3} md={2}>
          <PathNavigationBar fixed={fixed} />
        </Grid>
        <Grid item xs={0} sm={1} />
        <Grid item px={{ xs: 3 }} xs={12} sm={7}>
          <Overview />
          <HowItWorks />
          <DataPrivacy />
          <GetStartedToday />
        </Grid>
        <Grid item xs={0} sm={1} md={2} />
      </Grid>
      <Footer />
    </Box>
  );
};

export default HomePage;
